import { type UseQueryResult, useQuery } from 'react-query';
import {
  CompanyAccountingPolicyService,
  type PagedResultDto_CompanyAccountingPolicyGroupDto,
} from '../../services/wealthlane-identity-services';

const useGetCompanyAccountingPolicyGroups = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<PagedResultDto_CompanyAccountingPolicyGroupDto | undefined, unknown> => {
  return useQuery(['getCompanyAccountingPolicyGroups'], async () => {
    return await handleRequest(
      CompanyAccountingPolicyService.getApiIdentityApiCompanyAccountingPolicyGroup()
    );
  });
};

export default useGetCompanyAccountingPolicyGroups;
